/** Number of Leitner boxes. New cards start in box 1, mastered cards end up in box 5. */
export const BOX_COUNT = 5;

export type Card = {
  /** Stable id derived from the word pair and its group, so progress survives re-imports. */
  id: string;
  /** Word in the learner's own language, e.g. "Haus". */
  native: string;
  /** Word in the foreign language, e.g. "maison". */
  foreign: string;
  /** Learning goal this card belongs to, e.g. "Lernziel 01". Empty means none. */
  group: string;
  /** Leitner box, 1..BOX_COUNT. */
  box: number;
  /** How often this card has been asked. */
  asked: number;
  /** How often it was answered correctly. */
  correct: number;
  /** Timestamp of the last time the card was asked. */
  lastAsked: number | null;
};

export type VocabSet = {
  id: string;
  name: string;
  /** Language code of the learner's own language, e.g. "DE". */
  nativeLang: string;
  /** Language code of the language being learned, e.g. "FR". */
  foreignLang: string;
  createdAt: number;
  updatedAt: number;
  cards: Card[];
};

export type AppData = {
  version: number;
  sets: VocabSet[];
};

/** Which of the two words is shown as the question. */
export type Direction = 'native2foreign' | 'foreign2native' | 'mixed';

export type QuizMode = 'choice' | 'typing' | 'flashcard';

/** A resolved direction for a single question (never "mixed"). */
export type AskDirection = 'native2foreign' | 'foreign2native';

export type RoundSettings = {
  mode: QuizMode;
  direction: Direction;
  length: number;
  /** Learning goal to practise, or null for the whole set. */
  group: string | null;
};

export type Question = {
  card: Card;
  direction: AskDirection;
  prompt: string;
  answer: string;
  /** Only filled for multiple choice: the correct answer plus distractors, shuffled. */
  options?: string[];
};

export type AnswerGrade = 'correct' | 'near' | 'wrong';

export type RoundMistake = {
  cardId: string;
  prompt: string;
  answer: string;
  given: string;
};
